import {
  ADD_GRN_HISTORY,
  CREATE_GRN,
  CREATE_INDENT,
  CREATE_PURCHASE_ORDER,
  DELETE_INDENT,
  DELETE_PURCHASE_ORDER,
  DELETE_PURCHASE_ORDER_ITEM,
  LIST_OF_INDENT,
  LIST_OF_PURCHASE_ORDER,
  PURCHASE_ORDER_PAYMENT,
  UPDATE_INDENT,
  UPDATE_PURCHASE_ORDER,
  VIEW_INDENT,
  VIEW_PURCHASE_ORDER,
  VIEW_PURCHASE_ORDER_PAYMENT_HISTORY,
  VIEW_PURCHASE_ORDER_WO_RO,
} from "./ApiRoutes";
import { authData } from "./services";

export const createIndent = async (data: object) => {
  const response = await authData.post(CREATE_INDENT, data);
  return response?.data;
};
export const updateIndent = async (id: number, data: object) => {
  const response = await authData.put(`${UPDATE_INDENT}${id}`, data);
  return response?.data;
};
export const listOfIndent = async (data: object) => {
  const response = await authData.post(LIST_OF_INDENT, data);
  return response?.data;
};
export const viewIndent = async (id: number) => {
  const response = await authData.get(`${VIEW_INDENT}${id}`);
  return response?.data;
};
export const deleteIndentApi = async (id: number) => {
  const response = await authData.delete(`${DELETE_INDENT}${id}`);
  return response?.data;
};
export const createPurchaseOrder = async (data: object) => {
  const response = await authData.post(CREATE_PURCHASE_ORDER, data);
  return response?.data;
};
export const createGRN = async (id: number, data: object) => {
  const response = await authData.post(`${CREATE_GRN}${id}`, data);
  return response?.data;
};
export const addGRNHistory = async (id: number, data: object) => {
  const response = await authData.post(`${ADD_GRN_HISTORY}${id}`, data);
  return response?.data;
};
export const updatePurchaseOrder = async (id: number, data: object) => {
  const response = await authData.put(`${UPDATE_PURCHASE_ORDER}${id}`, data);
  return response?.data;
};
export const listOfPurchaseOrder = async (data: object) => {
  const response = await authData.post(LIST_OF_PURCHASE_ORDER, data);
  return response?.data;
};
export const viewPurchaseOrder = async (id: number) => {
  const response = await authData.get(`${VIEW_PURCHASE_ORDER}${id}`);
  return response?.data;
};
export const deletePurchaseOrderApi = async (id: number) => {
  const response = await authData.delete(`${DELETE_PURCHASE_ORDER}${id}`);
  return response?.data;
};
export const deletePurchaseOrderItemApi = async (id: number) => {
  const response = await authData.delete(`${DELETE_PURCHASE_ORDER_ITEM}${id}`);
  return response?.data;
};
export const addPurchaseOrderPayment = async (id: number, data: object) => {
  const response = await authData.post(`${PURCHASE_ORDER_PAYMENT}${id}`, data);
  return response?.data;
};
export const viewPurchaseOrderPaymentHistory = async (id: number) => {
  const response = await authData.get(
    `${VIEW_PURCHASE_ORDER_PAYMENT_HISTORY}${id}`
  );
  return response?.data;
};
export const viewPurchaseOrderWORO = async (id: number) => {
  const response = await authData.get(`${VIEW_PURCHASE_ORDER_WO_RO}${id}`);
  return response?.data;
};

export const createPOGRN = async (id: number, data: object) => {
  const response = await authData.post(`${CREATE_GRN}${id}`, data);
  return response?.data;
};